"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class Iterator {
  constructor(value) {
    this.value = value;
  }
  static of(value) {
    return new this(value);
  }
  filter(matcher) {
    if (this.isEmpty()) {
      return this;
    }
    const filtered = {};
    Object.keys(this.value).filter(key => matcher(key, this.value[key])).forEach(key => filtered[key] = this.value[key]);
    return Iterator.of(filtered);
  }
  get() {
    return this.value;
  }
  isEmpty() {
    return this.value === null || this.value === undefined;
  }
}

/**
 * オブジェクトの無効なvalueを持つ項目を削除する
 * @param {object} items -チェックするアイテム
 * @returns {object} - 無効なvalueの項目を削除したオブジェクト
 */
const emptyCheck = items => {
  return Iterator.of(items).filter((key, value) => {
    if (typeof value === 'string') {
      return value !== '';
    } else if (typeof value === 'object') {
      const type = Object.prototype.toString.call(value);
      if (type === '[object Object]') {
        return Object.keys(value).length > 0;
      } else if (type === '[object Array]') {
        return value.length > 0;
      }
    }
    return true;
  }).get();
};
var _default = exports.default = emptyCheck;